export default "__VITE_ASSET__BSspWS1u__"